













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default  class AdminFooter extends Vue {

    @Prop({type: String, default: '' })
    private copyright!: string;

    @Prop({type: Array, default: [] })
    private linkList!: Array<{name: string, icon: string, link: string}>;

}
